require("../../node_modules/jquery-expander/jquery.expander");

module.exports = {
  init: () => {
    $(".truncate").expander({
      slicePoint: 900, // default is 100
      sliceOn: "</p>",
      expandPrefix: " ", // default is '... '
      expandText: "Læs mere", // default is 'read more'
      preserveWords: true,
      expandEffect: "fadeIn",
      expandSpeed: 250,
      userCollapse: false,
      summaryClass: "summary_view",
      detailClass: "details_view",
    });
  },
};
